import { useState } from 'react';

function Franchise(params) {
    const franchise = params.franchise;
    const [showDetails, setShowDetails] = useState(false);
    const user = params.user;

    return (
        <div style={{
            backgroundColor: '#fff',
            borderRadius: '16px',
            border: '1px solid #e5e7eb',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
        }}>
            {/* Franchise Title and Description */}
            <div>
                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: '#111827' }}>
                    {franchise.name}
                </h3>
                <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                    {franchise.nameOriginal}
                </div>
                <div style={{ fontSize: '14px', color: '#4f46e5', marginTop: '5px' }}>
                    Slug: {franchise.slug}
                </div>
            </div>

            {/* Franchise Description */}
            <div style={{
                fontSize: '14px',
                color: '#4b5563',
                lineHeight: '1.5',
                display: '-webkit-box',
                WebkitLineClamp: '3',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
            }}>
                {franchise.description}
            </div>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: '10px' }}>
                <button
                    onClick={() => params.onEditClicked(franchise)}
                    style={{
                        padding: '10px 20px',
                        borderRadius: '10px',
                        border: 'none',
                        backgroundColor: '#4f46e5',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600',
                        flex: 1
                    }}
                >
                    Редагувати
                </button>
            </div>

            {/* Toggle additional details (e.g., franchise serials) */}
            <div>
                <button
                    onClick={() => setShowDetails(!showDetails)}
                    style={{
                        width: '100%',
                        padding: '10px',
                        borderRadius: '10px',
                        border: '1px solid #e5e7eb',
                        backgroundColor: '#fff',
                        cursor: 'pointer',
                        color: '#4b5563',
                        fontSize: '13px',
                        fontWeight: '500'
                    }}
                >
                    {showDetails ? '🔼 Сховати інформацію' : '🔽 Додаткова інформація'}
                </button>
                {showDetails && (
                    <div style={{ marginTop: '12px', padding: '10px', backgroundColor: '#f9fafb', borderRadius: '10px' }}>
                        <p style={{ fontSize: '14px', margin: 0 }}>Серіалів у франшизі: {franchise.franchiseSerials?.length || 0}</p>
                        {/*todo show list of serials*/}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Franchise;